import { TrashIcon } from '@heroicons/react/24/solid'
import Checkbox from '../../../../../UI/Checkbox/Checkbox'
import RemoveConfirmation from '../../../../../UI/RemoveConfirmation/RemoveConfirmation'
import useConceptConfiguration from '../../ConceptCalculation/useConceptConfiguration'
import { getPrettyDate } from '../../../../../../utility'
import props from '../../../../../../redux/props'
import { useSelector } from 'react-redux'
import { Concept } from '../../../../../../types/Survey/Analysis/Concept'
import Copy from './Copy'
type Props = {
  concept: Concept
  isActive: boolean
}

const SingleConcept: React.FC<Props> = ({ concept, isActive }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { setActiveConcept, graphConceptUUIDList, toggleGraphConcept, removeConcept } = useConceptConfiguration()

  return (
    <div key={concept.uuid} className={`flex justify-between p-2 items-center ${isActive ? 'bg-cyan text-white' : ''}`}>
      <div className={`flex gap-3 items-center`} key={concept.uuid}>
        <Checkbox width="fit" checked={graphConceptUUIDList.includes(concept.uuid)} onChange={toggleGraphConcept(concept.uuid)} />
        <div className="cursor-pointer hover:underline" onClick={() => setActiveConcept(concept.uuid)} key={concept.name}>
          {concept.name}
        </div>
      </div>
      <div className="flex gap-2 items-center shrink-0">
        <div className="text-xs">
          {t.survey.analysis.concept.datasetCreatedOn}
          {getPrettyDate(concept.createdOn)}
        </div>
        <RemoveConfirmation itemName={concept.name} confirmationCallback={() => removeConcept(concept.uuid)}>
          <TrashIcon className="fill-blue opacity-40 hover:opacity-100 transition-all w-5 cursor-pointer" />
        </RemoveConfirmation>
        <Copy concept={concept} />
      </div>
    </div>
  )
}

export default SingleConcept
